var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBreadcrumbs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  fillRule: "evenodd",
  d: "m10.449 8.276-2-4A.5.5 0 0 0 7.999 4h-2a.5.5 0 0 0-.447.723L7.44 8.5l-1.888 3.776a.5.5 0 0 0 .447.724h2a.5.5 0 0 0 .447-.277l2-4a.5.5 0 0 0 .002-.446m-4.5 0-2-4A.5.5 0 0 0 3.5 4H1.5a.5.5 0 0 0-.447.723L2.94 8.5l-1.888 3.776A.5.5 0 0 0 1.5 13h2a.5.5 0 0 0 .447-.277l2-4a.5.5 0 0 0 .003-.446m6.999-4 2 4a.5.5 0 0 1-.003.447l-2 4a.5.5 0 0 1-.447.276h-2a.5.5 0 0 1-.447-.724L11.939 8.5 10.05 4.723A.5.5 0 0 1 10.499 4h2a.5.5 0 0 1 .45.276",
  clipRule: "evenodd"
})));
export default SvgBreadcrumbs;